import { array, string, type } from "superstruct";

import { CartItemSchema } from "./CartItemSchema";

export const CartSchema = type({
    token: string(),
    items: array(CartItemSchema),
});
